import { Backend } from "../Common/utils/axios";
import { CONSTANTS } from "../config/constants";
import { isFixtures } from "../Common/constants/EnvironmentalConstants";

export function getProfile(isRecruiterDomain = "no") {
  if (isFixtures()) {
    return new Promise((resolve, reject) =>
      resolve({
        data: {
          userId: 62453,
          username: "user@example.com",
          fullname: "Full Name",
          designation: "Super Admin",
          email: "user@example.com",
        },
      })
    );
  }
  return Backend.get(
    `${CONSTANTS.USER_INFO_API_ENDPOINT}?isRecruiterDomain=${isRecruiterDomain}`
  );
}
